import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { IResponse as IClientResponse } from 'api/endpoints/useGetClient';

// typ trader dashboard
interface ITraderDashboardSlice {
  // Placeholder dla przyszłych danych dashboardu handlowca
  isLoading: boolean;
  // aktualny klient w kontekście panelu handlowca (np. karta klienta)
  currentClientId: number | null;
  currentClient: IClientResponse | null;
  // todo do rozwiniecia przy pracy nad panelem handlowca
}

// dane inicjalizacyjne
const initialState: ITraderDashboardSlice = {
  isLoading: false,
  currentClientId: null,
  currentClient: null
};

export const traderDashboardSlice = createSlice({
  name: 'traderDashboard',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<ITraderDashboardSlice['isLoading']>) => {
      state.isLoading = action.payload;
    },
    setCurrentClient: (
      state,
      action: PayloadAction<{ clientId: number | null; client: IClientResponse | null }>
    ) => {
      state.currentClientId = action.payload.clientId;
      state.currentClient = action.payload.client;
    }
  }
});

export const traderDashboardSliceActions = traderDashboardSlice.actions;

export default traderDashboardSlice.reducer;
